<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择保险费"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{scope.row[scope.column.property] / 100}}</span>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  annualCostList,
} from 'api/cost';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'plateNumber',
      tableSelectTar: 'id',
      searchBoxDataTmpl: {
        form: [
          { // 创建时间
            label: '创建时间',
            value: 'createDate',
            type: 'date',
            default: [],
            placeholder: '请选择创建时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '保险类型',
            value: 'reviewType',
            type: 'select',
            placeholder: '请选择保险类型',
            options: [
              {
                label: '交强险',
                value: 3,
              },
              {
                label: '商业险',
                value: 4,
              },
              {
                label: '资产险',
                value: 0,
              },
            ],
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 保险单号
            label: '保险单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入保险单号',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
      ],
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号',
        },
        {
          prop: 'certificatesInsuranceTypeName',
          label: '保险类型',
        },
        {
          prop: 'agentCompany',
          label: '被保险人',
        },
        {
          prop: 'insuranceStartDate',
          label: '起保日期',
        },
        {
          prop: 'insuranceEndDate',
          label: '终保日期',
        },
        {
          prop: 'certificatesInsuranceFee',
          label: '保费',
        },
        {
          prop: 'stateName',
          label: '是否退保',
        },
        {
          prop: 'insuranceTerminationDate',
          label: '退保时间',
        },
        {
          prop: 'createTime',
          label: '创建时间',
        },
      ],
    };
  },
  methods: {
    getListApi: annualCostList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      if (searchBoxData.createDate[0]) {
        searchBoxData.createBeginDate = this.formatDate(searchBoxData.createDate[0], 1);
        searchBoxData.createEndDate = this.formatDate(searchBoxData.createDate[1], 1);
      }
      delete searchBoxData.insuranceDate;
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
